var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB1ConsumptionHeating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 19.92l2 2.17V41h-4V22.09l2-2.17zM30 41h4V26.09l-2-2.17-2 2.17V41zm-7 0h4V30.09l-2-2.17-2 2.17V41zm-7 0h4v-5.91l-2-2.17-2 2.17V41zM9 22.45l20.52-13 20.48 13V40h4V20.25L29.52 4.7 5 20.25V51h36v-4H9V22.45zm17.25 41.2a4 4 0 100 8 4 4 0 000-8zm10.67 0a4 4 0 100 8 4 4 0 000-8zm21.33 0a4 4 0 100 8 4 4 0 000-8zm10.67 0a4 4 0 100 8 4 4 0 000-8zM55.86 44L42.79 72h4.44l13.05-28h-4.42z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B1_Consumption_heating.5eb8fd15.svg";
export { SvgB1ConsumptionHeating as ReactComponent };